import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geometric-form',
  templateUrl: './geometric-form.component.html',
  styleUrls: ['./geometric-form.component.scss']
})
export class GeometricFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
